import { useQuery } from '@tanstack/react-query'
import { listShmpCourseWeeklyPlan } from '@/services/shmpService'
import type { ShmpCourseNumber, ShmpCourseWeeklyPlanRow } from '@/types'

export function useShmpCourseWeeklyPlan(params: {
  periodId: number | null
  courseNumber: ShmpCourseNumber | null
}) {
  const query = useQuery<ShmpCourseWeeklyPlanRow[], Error>({
    queryKey: ['shmp-course-weekly-plan', params.periodId, params.courseNumber],
    queryFn: () => listShmpCourseWeeklyPlan({
      periodId: params.periodId as number,
      courseNumber: params.courseNumber,
    }),
    enabled: params.periodId !== null,
    staleTime: 60_000,
  })

  return {
    data: query.data ?? [],
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refresh: query.refetch,
  }
}
